import { map, head, tail, toUpper, split, join } from 'ramda'

/* eslint-disable no-bitwise */
export const simpleHash = s => {
  let a = 1
  let c = 0
  let h
  let o
  if (s) {
    a = 0
    // eslint-disable-next-line no-plusplus
    for (h = s.length - 1; h >= 0; h--) {
      o = s.charCodeAt(h)
      a = ((a << 6) & 268435455) + o + (o << 14)
      c = a & 266338304
      a = c !== 0 ? a ^ (c >> 21) : a
    }
  }
  return String(a)
}
/* eslint-enable no-bitwise */

export const snakeToDisplay = str =>
  join(
    ' ',
    map(s => toUpper(head(s)) + tail(s), split('_', str))
  )

export const capitalize = (s = '') => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
